// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"82":"20b2c824","200":"8b948072","301":"f4b06abf"}[chunkId] + ".chunk.css");